export const builtInSkillNames = [
  'create-site',
  'edit-site',
  'extract-web-content',
  'translate-content',
] as const;

export const externalSkillNames = ['create-site', 'edit-site', 'translate-content'] as const;
